const formData = {
  full_name: '',
  mobile_number: '',
  email_address: '',
  hotel_name: '',
  hotel_address: '',
  operational_currently: '',
  are_you_a_owner: '',
  occupancy_status: '',
  structure_type_home: '',
  living_google_link: '',
  structure_type_commercial: '',
  furnishing_status: '',
  city: '',
  country: '',
  display_name: '',
  address: '',
  commercialspaces__have_operating_right: '',
  plot_area: '',
  selected_location: {},
  dial_code: null,
  flagPos: null,
  showSideMenu: false,
  last_year_revenue: '',
  revenue_without_tax: ''
};

export default formData;
